// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___3WpmV","input":"styles__input___3Mn3A"};